/* eslint-disable react-hooks/exhaustive-deps */
import React, {useContext, useEffect, useState, useMemo} from 'react';
import { useHistory, useParams } from 'react-router-dom';

import {makeStyles, Theme, Container, Grid, Button, Switch, TextField, MenuItem,Checkbox,CircularProgress,LinearProgress, IconButton} from '@material-ui/core';
import { DropzoneDialogBase } from 'material-ui-dropzone';

import { AppContext } from '../stores/AppStore';
import { UserContext } from '../stores/UserStore';
import { SecurityContext } from '../stores/SecurityStore';

import UnknowUserImg from '../assets/images/unknow-user.svg';
import LogoImg from '../assets/images/logo-manage-user.svg';

import ArrowBackOutlinedIcon from '@material-ui/icons/ArrowBackOutlined';
import DeleteIcon from '@material-ui/icons/Delete';


const useStyles = makeStyles((theme: Theme) => ({
    root: {
        padding: theme.spacing(2,2,0,2),
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'stretch',
        alignItems: 'stretch',
        height: '92vh'
    },
    header: {
        backgroundColor: 'transparent',
        flex: '50px 0',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        marginBottom: '10px'
    },
    toolbar: {
        // margin: 2
    },    
    backButton: {
        backgroundColor: '#FFFFFF',
        minWidth: '40px',
        marginRight: '10px'      
    },
    resetPasswordButton: {
        fontSize: 14,
        fontWeight: 500,
        color: theme.palette.primary.main,
        backgroundColor: theme.palette.text.primary,
        height: 32,
        marginRight: '5px',
        padding: '0px 20px',
        textTransform: 'none',
        boxShadow: '0 2px 4px 0 rgba(0,0,0,0.14)' 
    },
    saveButton: {
        fontSize: 14,
        fontWeight: 500,
        color: theme.palette.text.primary,
        backgroundColor: theme.palette.primary.main,
        height: 32,
        padding: '0px 30px',
        textTransform: 'none',
        boxShadow: '0 2px 4px 0 rgba(0,0,0,0.14)'  
    },
    title: {
        fontSize: 24,
        fontWeight: 700,
        marginRight: 16,
    },
    body: {
        flex: '1 0',
        margin: theme.spacing(0),
        borderTopLeftRadius: '8px',
        borderTopRightRadius: '8px',
        backgroundColor: '#FFFFFF',
        color: theme.palette.text.secondary,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'stretch',
        alignItems: 'stretch',
    },
    contentHeader: {
        flex: '30px 0',
        margin: theme.spacing(2,1,0),
        color: theme.palette.primary.main,
        fontSize: 16,
        fontStyle: 'italic'
    },
    contentCard: {
        flex: '1 0',
        margin: theme.spacing(0),
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'stretch',
        alignItems: 'flex-start',
    },
    card: {
        flex: '1 0',
        margin: theme.spacing(1,3),
        borderRadius: '8px',
        backgroundColor: '#F8F9FA',
        color: theme.palette.text.secondary,
        // boxShadow: '0 8px 16px 0 rgba(0,0,0,0.14)',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        alignItems: 'stretch',
        minHeight: '73vh',
        height: '73vh',
        overflow: 'auto',
        '&::-webkit-scrollbar': {
            backgroundColor: '#F8F9FA',
            width:'12px'          
        },
        '&::-webkit-scrollbar-track': {
          backgroundColor:'#F8F9FA'
        },        
        '&::-webkit-scrollbar-thumb': {
          backgroundColor:'#cecece',
          borderRadius:'16px',
          border:'2px solid #F8F9FA'
        },        
        '&::-webkit-scrollbar-button': {display: 'none'}
    },
    cardPicture: {
        margin: theme.spacing(3),
        height: '160px',
        width: '160px',
        boxShadow: '0 3px 5px 0 rgba(0,0,0,0.14)',
        borderRadius: '100px',
        backgroundColor: theme.palette.text.primary
    },
    cardRow: {
        margin: theme.spacing(2),
        display: 'flex', 
        flexDirection: 'row'
    },
    cardItem: {
        width:  'calc(100% - 20px)',
        margin: theme.spacing(0,1),
        fontSize: 12,
        '& .MuiFormLabel-root': {
            color: '#666666'
        },
        '& .MuiInput-root': {
            color: '#000000',
            '& .MuiInputBase-input': {
                paddingLeft: '10px',
                backgroundColor: '#FFFFFF',
                height: '1.8em',
                borderRadius: '4px',
                boxShadow: 'inset 0 1px 3px 0 rgba(0,0,0,0.14)'                
            },
            '& .MuiSelect-select.MuiSelect-select': {
                paddingTop: '10px',
                paddingBottom: '0px'
            },
            '& .Mui-disabled': {
                opacity: 0.5
            }
        }
    },
    cardTitle: {
        width:  'calc(100% - 20px)',
        margin: theme.spacing(0,1),
        fontSize: 20,
        fontWeight: 300,
        color: '#666666'
    },
    cardApp: {
        width:  'calc(100% - 20px)',
        margin: theme.spacing(0,1),
        paddingBottom: theme.spacing(2),
        fontSize: 20,
        fontWeight: 300,
        color: '#666666',
        borderRadius: '8px',
        backgroundColor: '#FFFFFF',

        '& .MuiCheckbox-colorPrimary.Mui-disabled': {
            color: '#9e9e9e'
        }
    },
    switch: {
        '& .Mui-disabled': {
            color: '#009EE0'
        }
    },
    // menuItem: {
    //     '.MuiListItem-root.Mui-disabled': {
    //         // display: 'none',
    //         backgroundColor: 'red',
    //     }
    // }
}));

const ManageUser = () => {
    const history = useHistory();
    const classes = useStyles();
    const { appId, userId }: any = useParams();    
    const { applicationSearchText, setApplicationSearchText, showSuccessMessage, showErrorMessage, transformFileToBase64 } = useContext(AppContext);
    const { currentUser } = useContext(UserContext);

    const { getUserData, getUserPicture, uploadUserPicture, saveUserData, resetUserPassword } = useContext(SecurityContext);
    const [userData, setUserData] = useState(null);
    const [userPicture, setUserPicture] = useState(null);

    const [selectApp, setSelectApp] = useState(undefined);

    const [isLoading, setLoading] = useState(true);
    const [isLoadingPicture, setLoadingPicture] = useState(true);
    const [openPictureDialog, setOpenPictureDialog] = useState(false);
    const [pictureObjects, setPictureObjects] = useState([]);

    useEffect(() =>  {
        if (applicationSearchText) {
            setApplicationSearchText('');
            history.push('/search/users/'+applicationSearchText);
        }
    }, [applicationSearchText]);

    useEffect(() =>  {
        if (appId && userId) {
            init();
        }
    }, [appId, userId]);

    const init = () => {
        setLoadingPicture(true);
        getUserData(appId, userId).then(response => {
            if (response) {
                const data = response;
                // if (data.applications.length > 0) {
                //     setSelectApp(data.applications[0].id);
                // }
                setUserData(data);
                getUserPicture(userId).then(response => {
                    setUserPicture(response);
                }).catch(errorMessage => {
                    console.error(errorMessage);
                }).finally(() => {
                    setLoadingPicture(false);
                });          
            } else {
                history.replace('/home');
            }
        }).catch(errorMessage => {
            showErrorMessage(errorMessage);
        }).finally(() => {
            setLoading(false);            
        });    
    };

    const handleBack = () => {
        history.goBack()
    };

    const handleResetPassword = async () => {
        try {
            setLoading(true);
            await resetUserPassword(userData.email);
            showSuccessMessage('Password on user have been reseted');
        } catch (errorMessage) {
            showErrorMessage(errorMessage);
        } finally {
            setLoading(false);
        }       
    };

    const handleSave = async () => {

        try {
            setLoading(true);
            if (userData.isChangePicture && userPicture) {
                await uploadUserPicture(userData.id, userPicture);
            }
            const data = {
                id: userData.id,
                inactive: userData.inactive,
                firstName: userData.firstName,
                lastName: userData.lastName,
                phoneNumber: userData.phoneNumber,
                position: userData.position,
                company: userData.company,
                language: userData.language,
                country: userData.country,
                profiles: [],
                activeApps: []           
            }

            for (const profile of userData.profiles) {
                const profileCheck = data.profiles.find(x => x === profile.id);
                if (!profileCheck) {
                    data.profiles.push(profile.id);
                    // const appCheck = data.activeApps.find(x => x === profile.applicationId);
                    // if (!appCheck) {
                    //     data.activeApps.push(profile.applicationId);
                    // }    
                }
            }

            for (const app of userData.applications) {
                if (app.checked) {
                    const appCheck = data.activeApps.find(x => x === app.id);
                    if (!appCheck) {
                        data.activeApps.push(app.id);
                    }    
                }
            }

            await saveUserData(data);
            showSuccessMessage('Changes on User Profile have been saved');
        } catch (errorMessage) {
            showErrorMessage(errorMessage);
        } finally {
            setLoading(false);
        }       
    };

    const handleInactive = (event: React.ChangeEvent<HTMLInputElement>) => {
        const record = {...userData};
        const inactive = record.inactive === undefined ? true : !record.inactive;
        record.inactive = inactive;
        setUserData(record);
    }; 

    const handleAddProfile = () => {
        const data = {...userData};   
        const application = data.applications.find(app => app.id === selectApp);
        if (application) {
            application.checked = true;
            const profileCheck = data.profiles.filter(profile => profile.applicationId === application.id && profile.id === 'none' );
            if (profileCheck.length === 0) {
                const newProfile = {id: 'none', label: '',  applicationId: application.id};
                data.profiles.push(newProfile);
                setUserData(data);    
            }    
        }
    }; 

    const handleRemoveProfile = (applicationId, profileId) => (event) => {
        const data = {...userData};   
        const profiles = data.profiles;
        data.profiles = [];
        for (const profile of profiles) {
            if (profile.applicationId === applicationId) {
                if (profile.id !== profileId) {
                    data.profiles.push(profile);
                }    
            } else {
                data.profiles.push(profile);
            }
        }
        setUserData(data);    
    }; 

    const handleAppChange = (event: React.ChangeEvent<HTMLInputElement>) => {       
        setSelectApp(event.target.value);
    }; 
            
    const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        event.preventDefault();
        const record = {...userData};
        record[event.target.name] = event.target.value;
        setUserData(record);
    };        

    const handleProfileInputChange = (profile) => (event: React.ChangeEvent<HTMLInputElement>) => {
        event.preventDefault();
        const data = {...userData};         
        const newProfile = data.applications.find(app => app.id === profile.applicationId).profiles.find(profile => profile.id === event.target.value);
        newProfile.applicationId = profile.applicationId;
        const newProfiles = [];
        for (let p of data.profiles) {
            if (p.id === profile.id && p.applicationId === profile.applicationId) {
                newProfiles.push(newProfile);
            } else {
                newProfiles.push(p);
            }
        }
        data.profiles = newProfiles;
        setUserData(data);
    };    
    
    const handleCheckAppChange = (app) => (event: React.ChangeEvent<HTMLInputElement>) => {
        const data = {...userData};   
        const newApp = data.applications.find(x => x.id === app.id);
        newApp.checked = event.target.checked;
        setUserData(data);
    };     

    // const handleCheckAppChange = (profile) => (event: React.ChangeEvent<HTMLInputElement>) => {
    //     const data = {...userData};   
    //     const newProfile = data.profiles.find(x => x.id === profile.id);
    //     newProfile.checked = event.target.checked;
    //     setUserData(data);
    // };     

    const handleUploadUserPicture = () => {
        const file = pictureObjects[0].file;
        const reader = new FileReader();
        reader.readAsArrayBuffer(file);
    
        reader.onload = (e: ProgressEvent) => {
            const byteArray = (e.target as FileReader).result;
            const base64 = transformFileToBase64(byteArray);

            const record = {...userData};
            setUserPicture('data:' + file.type + ';base64, ' + base64);
            record.isChangePicture = true;
            setUserData(record);                
            setOpenPictureDialog(false);   
        };                                
    }

    const renderBody = useMemo(() => userData && <div className={classes.body}>
        <div className={classes.contentHeader}>
            {isLoading ? <LinearProgress color="primary" /> : <>
                <Switch
                    className={classes.switch}
                    checked={userData.inactive ? false : true }
                    onChange={handleInactive}
                    name="inactive"
                    disabled={!currentUser?.roles?.USER?.SAVE_RECORD}
                    color="primary"
                />            
                Active User
            </>}
        </div>
        <div className={classes.contentCard}>
            <div className={classes.card} style={{flex: '280px 0', alignItems: 'center', minHeight: '280px'}}>
                { !userPicture && isLoadingPicture ?  
                    <CircularProgress color="primary" style={{marginTop: '100px'}} /> 
                : 
                    <>
                        <img src={userPicture || UnknowUserImg} className={classes.cardPicture} alt="User" />
                        <Button color="primary" onClick={() => {
                            setPictureObjects([]);
                            setOpenPictureDialog(true);
                        }}>Change Picture</Button>
                    </> 
                }
            </div>
            <div className={classes.card}>
                <div className={classes.cardRow}>
                    <span className={classes.cardTitle}>User Information</span>
                    { userData.type === 'employee' && <img src={LogoImg} style={{width: '85x', height: '20px'}} alt="Logo" /> }
                </div>

                <div className={classes.cardRow}>
                    <TextField
                        label="First Name:"
                        required
                        placeholder="First Name"
                        id="firstName"
                        name="firstName"
                        className={classes.cardItem}
                        error={userData.firstName !== undefined && !userData.firstName}
                        value={userData.firstName}
                        onChange={handleInputChange}                            
                        fullWidth
                        //margin="dense"
                        // variant="outlined"
                        InputLabelProps={{shrink: true}}
                        />
                    <TextField
                        label="Last Name:"
                        required
                        placeholder="Last Name"
                        id="lastName"
                        name="lastName"
                        className={classes.cardItem}
                        error={userData.lastName !== undefined && !userData.lastName}
                        value={userData.lastName}
                        onChange={handleInputChange}                            
                        fullWidth
                        //margin="dense"
                        // variant="outlined"
                        InputLabelProps={{shrink: true}}
                        />
                </div>
                <div className={classes.cardRow}>
                    <TextField
                        label="Email:"
                        disabled
                        type="email"
                        placeholder="Email"
                        id="email"
                        name="email"
                        className={classes.cardItem}
                        // error={userData.email !== undefined && !userData.email}
                        value={userData.email}
                        // onChange={handleInputChange}                            
                        fullWidth
                        //margin="dense"
                        //variant="outlined"
                        InputLabelProps={{shrink: true}}
                        />
                </div>

                <div className={classes.cardRow}>
                    <TextField
                        label="Position:"
                        required
                        placeholder="Position"
                        id="position"
                        name="position"
                        className={classes.cardItem}
                        error={userData.position !== undefined && !userData.position}
                        value={userData.position}
                        onChange={handleInputChange}                            
                        fullWidth
                        //margin="dense"
                        //variant="outlined"
                        InputLabelProps={{shrink: true}}
                        />                                
                    <TextField
                        label="Company:"
                        required
                        placeholder="Company"
                        id="company"
                        name="company"
                        className={classes.cardItem}
                        error={userData.company !== undefined && !userData.company}
                        value={userData.company}
                        onChange={handleInputChange}                            
                        fullWidth
                        //margin="dense"
                        //variant="outlined"
                        InputLabelProps={{shrink: true}}
                        />
                    {/* <TextField
                        label="Country:"
                        required
                        placeholder="Country"
                        id="location"
                        name="location"
                        className={classes.cardItem}
                        error={userData.location !== undefined && !userData.location}
                        value={userData.location}
                        onChange={handleInputChange}                            
                        fullWidth
                        //margin="dense"
                        //variant="outlined"
                        InputLabelProps={{shrink: true}}
                        /> */}
                </div>

                {/* <div className={classes.cardRow}>
                    <TextField
                        label="Address:"
                        required
                        placeholder="Address"
                        id="address"
                        name="address"
                        className={classes.cardItem}
                        error={userData.address !== undefined && !userData.address}
                        value={userData.address}
                        onChange={handleInputChange}                            
                        fullWidth
                        //margin="dense"
                        //variant="outlined"
                        InputLabelProps={{shrink: true}}
                        />
                </div> */}

                {/* <div className={classes.cardRow}>
                    <TextField
                        label="ZipCode:"
                        required
                        placeholder="ZipCode"
                        id="zipCode"
                        name="zipCode"
                        className={classes.cardItem}
                        error={userData.zipCode !== undefined && !userData.zipCode}
                        value={userData.zipCode}
                        onChange={handleInputChange}                            
                        fullWidth
                        //margin="dense"
                        //variant="outlined"
                        InputLabelProps={{shrink: true}}
                        />
                    <TextField
                        label="City:"
                        required
                        placeholder="City"
                        id="city"
                        name="city"
                        className={classes.cardItem}
                        error={userData.city !== undefined && !userData.city}
                        value={userData.city}
                        onChange={handleInputChange}                            
                        fullWidth
                        //margin="dense"
                        //variant="outlined"
                        InputLabelProps={{shrink: true}}
                        />
                </div> */}

                <div className={classes.cardRow}>
                    <TextField
                        label="Country:"
                        // required
                        placeholder="Country"
                        id="country"
                        name="country"
                        className={classes.cardItem}
                        // error={userData.country !== undefined && !userData.country}
                        value={userData.country}
                        onChange={handleInputChange}                            
                        fullWidth
                        //margin="dense"
                        //variant="outlined"
                        InputLabelProps={{shrink: true}}
                        />
                    <TextField
                        label="Phone:"
                        // required
                        placeholder="Phone"
                        id="phoneNumber"
                        name="phoneNumber"
                        className={classes.cardItem}
                        // error={userData.phoneNumber !== undefined && !userData.phoneNumber}
                        value={userData.phoneNumber}
                        onChange={handleInputChange}                            
                        fullWidth
                        //margin="dense"
                        //variant="outlined"
                        InputLabelProps={{shrink: true}}
                        />
                </div>

                <div className={classes.cardRow}>
                    {/* <TextField
                        select
                        label="User Type:"
                        required
                        placeholder="User Type"
                        id="type"
                        name="type"
                        className={classes.cardItem}
                        error={userData.type !== undefined && !userData.type}
                        value={userData.type}
                        onChange={handleInputChange}                            
                        fullWidth
                        //margin="dense"
                        //variant="outlined"
                        InputLabelProps={{shrink: true}}>
                            {   
                                userTypes.map((type) => (
                                    <MenuItem key={type.value} value={type.value}>
                                        {type.text}                                                
                                    </MenuItem>
                                ))                                    
                            }
                    </TextField> */}
                    <TextField
                        select
                        label="Default Language:"
                        required
                        placeholder="Default Language"
                        id="language"
                        name="language"
                        className={classes.cardItem}
                        error={userData.language !== undefined && !userData.language}
                        value={userData.language}
                        onChange={handleInputChange}                            
                        fullWidth
                        //margin="dense"
                        //variant="outlined"
                        InputLabelProps={{shrink: true}}>
                            <MenuItem value="pt-BR">Portuguese</MenuItem>                                    
                            <MenuItem value="en">English</MenuItem>                                    
                            <MenuItem value="es">Spanish</MenuItem>                                    
                    </TextField>
                    <div className={classes.cardItem}>&nbsp;</div>
                </div>

                <div className={classes.cardRow}></div>
            </div>
            <div className={classes.card}>
                <div className={classes.cardRow} style={{flexDirection: 'column'}}>
                    <span className={classes.cardTitle}>Applications</span>
                    <span className={classes.cardTitle} style={{fontSize: '14px'}}>Please manage permissions for {userData.firstName}</span>
                </div>

                <div className={classes.cardRow}>
                    <TextField
                        select
                        label="Applications:"
                        required
                        placeholder="Applications"
                        id="application"
                        name="application"
                        className={classes.cardItem}
                        // error={userData.type !== undefined && !userData.type}
                        value={selectApp}
                        onChange={handleAppChange}                            
                        fullWidth
                        //margin="dense"
                        //variant="outlined"
                        InputLabelProps={{shrink: true}}>
                            {   
                                userData.applications.filter(app => !app.disabled).map((app) => (
                                    <MenuItem key={app.id} value={app.id}>
                                        {app.label}                                                
                                    </MenuItem>
                                ))                                    
                            }
                    </TextField>
                    
                    <Button variant="contained" className={classes.resetPasswordButton} style={{alignSelf: 'flex-end', marginBottom: '5px'}} onClick={handleAddProfile} >
                        Add
                    </Button>
                </div>

                {
                    userData.applications.filter(app => {
                        const profiles = userData.profiles.filter(profile => profile.applicationId === app.id);
                        if (profiles.length > 0) {
                            return true;
                        }
                        return false;
                        // return app.id;
                    }).map(app => (
                        <div key={app.id} className={classes.cardRow} style={{margin: '6px 16px'}}>
                            <div className={classes.cardApp}>
                                <div> 
                                    <Checkbox
                                        disabled={app.disabled}  
                                        checked={app.checked} 
                                        onChange={handleCheckAppChange(app)}
                                        name="checkedB" color="primary" />
                                    { app.label } 
                                </div>                
                                { userData.profiles.filter(profile => profile.applicationId === app.id).map(profile => (<div style={{display: 'flex', flexDirection:'row'}}>
                                        <TextField
                                            select
                                            // label="User Profile:"
                                            required
                                            disabled={!app.checked || app.disabled || profile.disabled}  
                                            placeholder="User Profile"
                                            id={'profile-'+profile.id}
                                            name={'profile-'+profile.id}
                                            className={classes.cardItem}
                                            // error={userData.'type !== undefined && !userData.type}
                                            value={profile.id}
                                            onChange={handleProfileInputChange(profile)}                            
                                            fullWidth
                                            //margin="dense"
                                            //variant="outlined"
                                            // InputLabelProps={{shrink: true}}
                                            >
                                                {   
                                                    app.profiles.map((appProfile) => (
                                                        <MenuItem style={{display: appProfile.disabled || userData.profiles.find(x => x.id === appProfile.id) ? 'none' : 'block'}} key={appProfile.id} disabled={appProfile.disabled || userData.profiles.find(x => x.id === appProfile.id)} value={appProfile.id}>
                                                            {appProfile.label}                                                
                                                        </MenuItem>
                                                    ))                                    
                                                }
                                        </TextField>
                                        <IconButton color="primary" aria-label="Remove Profile" component="span" onClick={handleRemoveProfile(app.id, profile.id)} disabled={!app.checked || app.disabled || profile.disabled}>
                                            <DeleteIcon />
                                        </IconButton>                                        
   
                                </div>)) }

                            </div>
                        </div>
                    ))                                    
                }
            </div>
        </div>
    </div>, [userData, userPicture, selectApp, isLoading, isLoadingPicture]); 


    return (
        <Container className={classes.root} maxWidth="xl">
            <Grid container spacing={0} className={classes.header}>
                <span className={classes.title}>
                    <Button className={classes.backButton} color="primary" component="span" onClick={handleBack}>
                        <ArrowBackOutlinedIcon/>
                    </Button> 
                    
                    {userData && userData.firstName + ' ' + userData.lastName}
                </span>
                <div className={classes.toolbar}>
                    { currentUser && <>
                        <Button variant="contained" className={classes.resetPasswordButton} onClick={handleResetPassword} >
                            Reset Password
                        </Button>
                        <Button variant="contained"  className={classes.saveButton} onClick={handleSave} >
                            Save
                        </Button>
                    </> }
                </div>
            </Grid>
            { renderBody }

            <DropzoneDialogBase
                dialogTitle="Upload Picture"
                acceptedFiles={['image/*']}
                fileObjects={pictureObjects}
                cancelButtonText={"Cancel"}
                submitButtonText={"Submit"}
                maxFileSize={6291456}
                filesLimit={1}
                open={openPictureDialog}
                onAdd={newFileObjs => {
                    console.log('onAdd', newFileObjs);
                    setPictureObjects(newFileObjs);
                }}
                onDelete={deleteFileObj => {
                    console.log('onDelete', deleteFileObj);
                    setPictureObjects([]);
                }}
                onClose={() => setOpenPictureDialog(false)}
                onSave={handleUploadUserPicture}
                showPreviews={false}
                showFileNamesInPreview={false}
                showPreviewsInDropzone={true}
            />


        </Container>
    );
};

export default ManageUser;
